/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Draft({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#Draft_svg__a)"><g clipPath="url(#Draft_svg__b)"><path fill="currentColor" d="M.4 13v-1a.6.6 0 1 1 1.2 0v1c0 .22.18.4.4.4h1.2a.6.6 0 1 1 0 1.2H2A1.6 1.6 0 0 1 .4 13m14 0v-1a.6.6 0 1 1 1.2 0v1a1.6 1.6 0 0 1-1.6 1.6h-1.2a.6.6 0 1 1 0-1.2H14a.4.4 0 0 0 .4-.4M.4 9V7a.6.6 0 1 1 1.2 0v2A.6.6 0 1 1 .4 9m0-5V3A1.6 1.6 0 0 1 2 1.4h1.2a.6.6 0 1 1 0 1.2H2a.4.4 0 0 0-.4.4v1A.6.6 0 1 1 .4 4m14 0V3a.4.4 0 0 0-.4-.4h-1.2a.6.6 0 1 1 0-1.2H14A1.6 1.6 0 0 1 15.6 3v1a.6.6 0 1 1-1.2 0M9.2 1.4a.6.6 0 1 1 0 1.2H6.8a.6.6 0 1 1 0-1.2z" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="m8.078 11.272 1.88 1.88M6.44 14.791l2.4-.466a2 2 0 0 0 1.033-.549L14.5 9.15a1.71 1.71 0 0 0-2.418-2.418l-4.627 4.627a2 2 0 0 0-.549 1.034z" /></g><path stroke="currentColor" strokeLinecap="round" strokeWidth={1.2} d="M4 5h4" /></g><defs><clipPath id="Draft_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath><clipPath id="Draft_svg__b"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;